module.exports = __webpack_public_path__ + "static/img/img-pak-djunaedi.2cacbe2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing_page/img-pak-djunaedi.png
// module id = DV+J
// module chunks = 36